import { DialogTheme } from '../../../enums';
import { SmallDialogSettings } from '../../../interfaces';

export const smallDialogSettingsInitial: SmallDialogSettings = {
  isActive: false,
  isLoading: false,
  header: '',
  content: '',
  acceptButton: undefined,
  closeButtonAction: (): void => undefined,
  cancelButton: undefined,
  theme: DialogTheme.Small,
};
